<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <span :class="preCls + 'filter-label'">所属客户</span>
            <Select v-model="filter.customerId"
                :class="preCls + 'select-public-style'"
                transfer
                clearable
                placeholder="全部客户">
                <Option v-for="(item, index) in customerList"
                    :value="item.id"
                    :key="index">
                    {{item.customerName}}
                </Option>
            </Select>
            <label>开始日期</label>
            <DatePicker v-model="startDate"
                transfer
                :class="preCls + 'select-public-style'"
                type="date"
                @on-change="clearFast"></DatePicker>
            <label>结束日期</label>
            <DatePicker v-model="endDate"
                transfer
                :class="preCls + 'select-public-style'"
                type="date"
                @on-change="clearFast"></DatePicker>
            <check-tag-group style="display: inline-block"
                v-model="fastDate"
                color="primary"
                @on-change="getEndStart">
                <check-tag v-for="item in fastDateList"
                    :name="item.id"
                    :key="item.id">{{item.text}}</check-tag>
            </check-tag-group>
            <Tabs class="router-view"
                :animated="false"
                v-model="active">
                <TabPane label="待派工单"
                    :index="1"
                    name="orderWait">
                    <Access name="orderWait">
                        <router-view :date="filter"
                            v-if="active == 'orderWait'"
                            :name="$access.aliasToUri('orderWait')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="已派工单"
                    :index="2"
                    name="orderAlready">
                    <Access name="orderAlready">
                        <router-view :date="filter"
                            v-if="active == 'orderAlready'"
                            :name="$access.aliasToUri('orderAlready')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="工单分析"
                    :index="3"
                    name="orderAnalysis">
                    <Access name="orderAnalysis">
                        <router-view :date="filter"
                            v-if="active == 'orderAnalysis'"
                            :name="$access.aliasToUri('orderAnalysis')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="工单监控"
                    :index="4"
                    name="orderMonitor">
                    <Access name="orderMonitor">
                        <router-view :date="filter"
                            v-if="active == 'orderMonitor'"
                            :name="$access.aliasToUri('orderMonitor')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="工单咨询"
                    :index="5"
                    name="orderConsult">
                    <Access name="orderConsult">
                        <router-view :date="filter"
                            v-if="active == 'orderConsult'"
                            :name="$access.aliasToUri('orderConsult')"></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'ivux'
import { customerList } from '@/api/customer-manage'
import dayjs from 'dayjs'

export default {
    components: {
        Tabs,
        TabPane
    },
    data() {
        return {
            active: 'orderWait',
            fastDateList: [
                { id: 7, text: '近7天' },
                { id: 30, text: '近30天' },
                { id: 90, text: '近90天' }
            ],
            filter: {
                customerId: this.$cache.customerId,
                startDate: this.$cache.startDate,
                endDate: this.$cache.endDate
            },
            fastDate: [],
            customerList: [],
        }
    },
    watch: {
        'filter.customerId': function(val) {
            this.$cache.customerId = val
        }
    },
    computed: {
        startDate: {
            get() {
                return this.filter.startDate ?
                    new Date(this.filter.startDate) :
                    ''
            },
            set(el) {
                this.filter.startDate = el ? dayjs(el).format('YYYY-MM-DD') : ''
                this.$cache.startDate = this.filter.startDate
            }
        },
        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : ''
            },
            set(el) {
                this.filter.endDate = el ? dayjs(el).format('YYYY-MM-DD') : ''
                this.$cache.endDate = this.filter.endDate
            }
        }
    },
    created() {
        customerList({ page: 1, pageSize: 999 }).then(res => {
            this.customerList = res.data.page.list
        })
    },

    methods: {
        getEndStart(el) {
            if (el && el.length) {
                let body = {
                    startDate: dayjs()
                        .subtract(el[0], 'day')
                        .format('YYYY-MM-DD'),
                    endDate: dayjs().format('YYYY-MM-DD')
                }
                this.filter = body
            }
        },
        clearFast() {
            this.fastDate = []
        },
    }
}
</script>